import React from "react";
import { Tooltip } from "antd";
import "../styles/eventFormStyles.css";
import { ChantInput } from "../../../../../../CommonComponents";
import useContentFormParams from "../hooks/useContentFormParams";

export const VirtualEventSection = ({
  videoConferenceLink,
  meetingCode,
  onLinkChange,
  onCodeChange,
}) => {
  const { formMode } = useContentFormParams();
  return (
    <div style={{ paddingTop: "12px" }}>
      <div className="event-form-label">
        Video Conference Link
        <Tooltip
          placement="topLeft"
          title={
            <div style={{ width: 400 }}>
              Add a video conference link / meeting code. In the Virtual Event
              card the standard &apos;Check-in&apos; option that appears on the
              event day will instead show &apos;Join&apos;. If offered, points
              will be awarded for attending.
            </div>
          }
        >
          <span style={{ marginLeft: "4px" }}>
            <i className="fa fa-question-circle-o" />
          </span>
        </Tooltip>
      </div>
      <div className="event-form-field-wrapper">
        <div style={{ display: "flex", gap: "12px" }}>
          <ChantInput
            value={videoConferenceLink}
            onChange={onLinkChange}
            placeholder="Add Link"
            disabled={formMode === "view"}
            style={{ flex: 1 }}
          />
          <ChantInput
            value={meetingCode}
            onChange={onCodeChange}
            placeholder="Meeting Code (Optional)"
            disabled={formMode === "view"}
            style={{ flex: 1 }}
          />
        </div>
      </div>
    </div>
  );
};
